/* Core & libraries */
import React, { useEffect, useState } from "react";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";

/* Components */

/* Styles */

const DynamicImageLoader = ({ imageName, overrideProviderCode }) => {
  const userContext = useUserContext();

  const providerCode = overrideProviderCode?.toLowerCase() || userContext?.userInfo?.providerInfo?.providerCode?.toLowerCase();
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    if (!providerCode) return;
    import(`../../resources/images/${providerCode}-${imageName}`)
      .then(image => setImageSrc(image.default))
      .catch(error => console.error("Error loading image", error));
  }, [imageName, providerCode]);

  return imageSrc && <img src={imageSrc} alt="Loaded dynamically" />;
};

export default DynamicImageLoader;